export const ACTION_ADD_LOSSES_AND_COMPENSATIONS = 'ACTION_ADD_LOSSES_AND_COMPENSATIONS';
